import React, { useState } from 'react';
import { TextField, Button, Box, Grid, CircularProgress, Typography, InputAdornment, Paper, Avatar, Divider } from '@mui/material';
import { FaUserAlt, FaPhoneAlt } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { UpdateProfile } from '../../../../redux/actions/profileActions';
import { validateuserUpdate } from '../../../../utils/validation';
import useAlert from '../../../../hooks/useAlert';
const ProfileSettings = ({ formValues, setFormValues }) => {
  const dispatch = useDispatch();
  const { showSuccessProfileUpdate, showErrorAlertProfileUpdate } = useAlert();
  const { loading, error } = useSelector((state) => state.auth);
  const authUserId = useSelector(state => state?.auth?.user?.id);
  const token = useSelector(state => state?.auth?.user?.accessToken?.token);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    setFormErrors({ ...formErrors, [name]: '' });
  };
  const [formErrors, setFormErrors] = useState({});
  const updateProfile = async (e) => {

    e.preventDefault();
    formValues.userId = authUserId;
    const errors = validateuserUpdate(formValues);
  
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      try {
        await dispatch(UpdateProfile(formValues, token));
        showSuccessProfileUpdate();
      } catch (err) {
        showErrorAlertProfileUpdate();
        console.error("Güncelleme hatası:", err);
      }
    }
  };

  return (

    <Box component="form" onSubmit={updateProfile} sx={{ mt: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            size='small'

            name="firstName"
            fullWidth
            label="İsim"
            value={formValues?.firstName}
            onChange={handleInputChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FaUserAlt color="#6C63FF" />
                </InputAdornment>
              ),
            }}
            error={!!formErrors?.firstName}
            helperText={formErrors?.firstName}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            size='small'

            name="lastName"
            fullWidth
            label="Soyisim"
            value={formValues?.lastName}
            onChange={handleInputChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FaUserAlt color="#6C63FF" />
                </InputAdornment>
              ),
            }}
            error={!!formErrors?.lastName}
            helperText={formErrors?.lastName}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            size='small'

            name="phone"
            fullWidth
            label="Telefon"
            value={formValues?.phone}
            onChange={handleInputChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FaPhoneAlt color="#6C63FF" />
                </InputAdornment>
              ),
            }}
            error={!!formErrors?.phone}
            helperText={formErrors?.phone}
          />
        </Grid>

      </Grid>
      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          type="submit"
          variant="contained"
          sx={{
            mt: 4,
            mb: 2,
            borderRadius: 2,
            backgroundColor: '#1F1B45',
            color: '#FFFFFF',
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.875rem',
            padding: '10px 20px',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            '&:hover': {
              backgroundColor: '#2C285A',
            },
          }}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Güncelle'}
        </Button>
      </Grid>
      {error && <Typography color="error">{error.message}</Typography>}
    </Box>

  );
};

export default ProfileSettings;
